import { render, staticRenderFns } from "./SetTheme.vue?vue&type=template&id=34256bb6&scoped=true&"
import script from "./SetTheme.vue?vue&type=script&lang=js&"
export * from "./SetTheme.vue?vue&type=script&lang=js&"
import style0 from "./SetTheme.vue?vue&type=style&index=0&id=34256bb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34256bb6",
  null
  
)

export default component.exports